/* VIPA featured review curation, preview only.
   Applies exclusively to the genuine REVIEWS.io featured carousel.
   This is a curated selection; full reviews and aggregate ratings stay intact.
   The provider's min_review_percent setting is not reliably enforced,
   so review cards are checked against the provider's own star aria-label.
*/
(function () {
  'use strict';
  function reviewRating(card) {
    var a = card.getAttribute('aria-label') || '';
    var m = a.match(/\b([1-5])\s+out\s+of\s+5\s+stars?\b/i);
    if (m) return Number(m[1]);
    var stars = card.querySelector('.R-RatingStars');
    var txt = stars && stars.textContent ? stars.textContent.trim() : '';
    var t = txt.match(/\b([1-5])\s+stars?\b/i);
    if (t) return Number(t[1]);
    return null;
  }
  function ensureNote(section) {
    var title = section.querySelector(':scope > h2');
    if (!title || section.querySelector('.vipa-curated-reviews-note')) return;
    var note = document.createElement('p');
    note.className = 'vipa-curated-reviews-note';
    note.textContent = 'Featured 4- and 5-star customer reviews. Read all reviews on REVIEWS.io.';
    title.insertAdjacentElement('afterend', note);
  }
  function filter(section) {
    var lists = section.querySelectorAll('.R-ReviewsList-container');
    if (!lists.length) return;
    lists.forEach(function (list) {
      var cards = Array.prototype.slice.call(list.querySelectorAll('.R-ReviewsList__item'));
      if (!cards.length) return;
      var originalFirst = cards.find(function (node) {
        return node.id && node.id.indexOf('ReviewsList__item--first') === 0;
      });
      var firstId = originalFirst && originalFirst.id;
      var removed = 0, hasRated = false;
      cards.forEach(function (card) {
        var rating = reviewRating(card);
        if (rating === null) return;
        hasRated = true;
        if (rating < 4) {
          card.remove();
          removed++;
        }
      });
      if (firstId && !document.getElementById(firstId)) {
        var firstRemaining = list.querySelector('.R-ReviewsList__item');
        if (firstRemaining) {
          firstRemaining.setAttribute('data-vipa-original-card-id', firstRemaining.id || '');
          firstRemaining.id = firstId;
        }
      }
      if (hasRated) {
        ensureNote(section);
        section.setAttribute('data-vipa-featured-filter', '4-5');
        if (removed) section.setAttribute('data-vipa-featured-hidden', String(
          Number(section.getAttribute('data-vipa-featured-hidden') || 0) + removed
        ));
      }
    });
  }
  function start() {
    document.querySelectorAll('.vipa-real-reviews[data-vipa-review-kind="carousel"]').forEach(function (section) {
      if (section.hasAttribute('data-vipa-featured-observing')) return;
      section.setAttribute('data-vipa-featured-observing','true');
      var scheduled = false;
      function schedule() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          filter(section);
        });
      }
      var observer = new MutationObserver(schedule);
      observer.observe(section,{childList:true,subtree:true});
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
